module.exports = __webpack_public_path__ + "img/ic_24_team_gesundheit.aac12f4b.svg";